import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Small delay to let page load first
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const acceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-gray-200 shadow-lg">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1 pr-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-1">Cookie Consent</h3>
            <p className="text-sm text-gray-600">
              We use cookies to ensure you get the best experience on our website. 
              Necessary cookies are required for the site to function properly.{' '}
              <Link to="/cookies" className="text-emerald-600 hover:underline">
                View our Cookie Policy
              </Link>
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Button
              variant="outline"
              onClick={acceptNecessary}
              className="whitespace-nowrap"
            >
              Accept Necessary Only
            </Button>
            <Button
              onClick={acceptAll}
              className="bg-emerald-600 hover:bg-emerald-700 text-white whitespace-nowrap"
            >
              Accept All Cookies
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
